module.exports = __webpack_public_path__ + "img/pattern-up.ab706fe9.png";